export const ROI_REPORT_FIELDS = [
  {
    key: 'totalAbsentDays',
    label: 'Total Absenteeism Days in Last Quarter',
    group: 'Absence & Turnover Data',
    placeholder: 'Please specify'
  },
  {
    key: 'averageCostOfAbsents',
    label: 'Average Cost of Absenteeism per Day',
    group: 'Absence & Turnover Data',
    prefix: '£',
    placeholder: 'Please specify'
  },
  {
    key: 'employeeTurnoverRate',
    label: 'Employee Turnover Rate (Last Quarter)',
    group: 'Absence & Turnover Data',
    suffix: '%',
    placeholder: 'Please specify'
  },
  {
    key: 'replaceEmployCost',
    label: 'Cost to Replace an Employee',
    group: 'Absence & Turnover Data',
    prefix: '£',
    placeholder: 'Please specify'
  },
  {
    key: 'totalWellbeingProgramInvestment',
    label: 'Total Investment in Wellbeing Programs',
    group: 'Budget for Wellbeing Programs',
    prefix: '£',
    placeholder: 'Please specify'
  },
  {
    key: 'mentalHealthTrainingCost',
    label: 'Mental Health Training Cost',
    group: 'Budget for Wellbeing Programs',
    prefix: '£',
    placeholder: 'Please specify'
  },
  {
    key: 'wellbeingEventCost',
    label: 'Wellbeing Events Cost (e.g., workshops, activities)',
    group: 'Budget for Wellbeing Programs',
    prefix: '£',
    placeholder: 'Please specify'
  },
  {
    key: 'employeeAssistanceCost',
    label: 'Employee Assistance Program Cost',
    group: 'Budget for Wellbeing Programs',
    prefix: '£',
    placeholder: 'Please specify'
  },
  {
    key: 'employeeEngagement',
    label: 'Employee Engagement',
    hint: 'Average score from your internal engagement surveys',
    group: 'Engagement & Participation Data',
    placeholder: 'Please specify'
  },
  {
    key: 'programParticipation',
    label: 'Program Participation',
    hint: 'Percentage of employees participating in wellbeing programs',
    group: 'Engagement & Participation Data',
    suffix: '%',
    placeholder: 'Please specify'
  },
  {
    key: 'sickDaysReduced',
    label: 'Sick Days Reduced Due to Wellness Initiatives',
    hint: '% decrease',
    group: 'Additional Data Points',
    suffix: '%',
    placeholder: 'Please specify'
  },
  {
    key: 'productivityIncrease',
    label: 'Productivity Increase Due to Engagement Programs',
    hint: 'Quantified in hours or %',
    group: 'Additional Data Points',
    placeholder: 'Please specify'
  }
];
